/**
 * PixiJS interaction events enum for reference and future upgrades.
 */
export enum ScreenEvents {
  /**
   * Called on screen initialization.
   */
  Init = "init",
  /**
   * Called synchronously after screen initialization.
   */
  Start = "start",
  /**
   * Called on screen hide.
   */
  Hide = "hide",
  /**
   * Called on screen update.
   */
  Update = "update",
  /**
   * Called on screen resize.
   */
  Resize = "resize",
  /**
   * Called on screen post update.
   */
  PostUpdate = "postupdate",
  /**
   * Called on screen pause.
   */
  Pause = "pause",
  /**
   * Called on screen destroy.
   */
  Destroy = "destroy",
  /**
   * Called on transition in start.
   */
  TransitionInStart = "transitioninstart",
  /**
   * Called on transition in end.
   */
  TransitionInEnd = "transitioninend",
  /**
   * Called on transition out start.
   */
  TransitionOutStart = "transitionoutstart",
  /**
   * Called on transition out end.
   */
  TransitionOutEnd = "transitionoutend"
}
